import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../services/localstorage.service';
import { PanelService } from 'src/app/features/user-management/service/panel.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit{

  user;

  constructor(private localStore: LocalStorageService,
    private panelService: PanelService) {}

  ngOnInit(): void {
    this.panelService.getPanelUser(localStorage.getItem('userId'))
      .subscribe((res: any) => {
        this.user = res;
      })
  }

  logout() {
    this.localStore.removeToken();
    localStorage.removeItem('userId');
  }

}
